import { BROKER, BRAND } from "@/lib/constants";
import { Mail, Calendar, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-pp-forest-deep text-pp-bone pt-20 pb-10 relative"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-5">
              <span className="w-9 h-9 rounded-full bg-pp-terracotta flex items-center justify-center text-pp-bone font-serif text-xl">
                P
              </span>
              <span className="font-serif text-2xl">{BRAND.name}</span>
            </div>
            <p className="text-pp-bone/70 max-w-md leading-relaxed">
              Independent life insurance brokerage helping families protect the
              people they love—with honesty, clarity, and zero pressure.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-pp-bone/60 mb-5">
              Coverage
            </h4>
            <ul className="space-y-3 text-sm">
              {[
                "Term Life",
                "Whole Life",
                "Index Universal Life",
                "Final Expense",
                "Return of Premium",
              ].map((l) => (
                <li key={l}>
                  <a
                    href="#coverage"
                    className="text-pp-bone/80 hover:text-pp-bone transition-colors"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.2em] text-pp-bone/60 mb-5">
              Get in touch
            </h4>
            <div className="space-y-4 text-sm">
              <a
                href={`tel:${BROKER.phoneRaw}`}
                data-testid="footer-phone-link"
                className="flex items-center gap-3 text-pp-bone/85 hover:text-pp-terracotta transition-colors"
              >
                <Phone className="w-4 h-4 stroke-[1.5]" />
                {BROKER.phone}
              </a>
              <a
                href={`mailto:${BROKER.email}`}
                data-testid="footer-email-link"
                className="flex items-center gap-3 text-pp-bone/85 hover:text-pp-terracotta transition-colors"
              >
                <Mail className="w-4 h-4 stroke-[1.5]" />
                {BROKER.email}
              </a>
              <a
                href={BROKER.calendarUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-calendar-link"
                className="flex items-center gap-3 text-pp-bone/85 hover:text-pp-terracotta transition-colors"
              >
                <Calendar className="w-4 h-4 stroke-[1.5]" />
                Book a consultation
              </a>
            </div>
            <div className="mt-8 text-pp-bone/60 text-sm">
              <div className="font-medium text-pp-bone/90">{BROKER.name}</div>
              <div>{BROKER.title}</div>
              <div className="text-xs mt-1 text-pp-bone/55">NPN #{BROKER.npn}</div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-pp-bone/15 flex flex-col md:flex-row gap-4 md:items-center md:justify-between text-xs text-pp-bone/55">
          <p>
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </p>
          <p className="max-w-2xl md:text-right">
            Quotes shown are illustrative estimates only. Actual rates depend on
            carrier underwriting and medical review. Not a binding offer of
            coverage.
          </p>
        </div>
      </div>
    </footer>
  );
}
